import Grid from '@mui/material/Grid';
import ExecutionBlock from '../Execution/ExecutionBlock';
import Title from "../Shared/Title";
import Match from '../Match/Match';

const RowExecution = props => {
    return (
        <Grid container className="ContainerRow">
            <Grid item xs={4}>
                <Title
                    row
                    href={`/jobs/${(props.item.GSI1PK || '').substring(4)}`}
                    systems={props.systems}
                    label={props.item.JobName}
                />
            </Grid>

            <Grid item xs={6}>
                <ExecutionBlock
                    item={props.item}
                    maxWidth={props.maxWidth}
                    href
                />
            </Grid>
            <Grid item xs={2}>
                <Match type="executions" matches={props.matches.executions} />
            </Grid>
        </Grid>
    )
}

export default RowExecution;